export default class AttributesService {
  constructor($q, EquipmentService) {
    'ngInject';

    this.$q = $q;
    this.EquipmentService = EquipmentService;
    this._attrs = undefined;
  }

  getAttributeValuesByName(attrName) {
    return this.getAttributesList().then(attrsList => {
      const attr = attrsList.find(attr => attr.key === attrName);
      return attr && attr.values && attr.values.map(v => v.value);
    });
  }

  getAttributesList() {
    if (!this._attrs) {
      return this.EquipmentService.getAllTags().then(response => {
        this._attrs = response.data.data;
        return this._attrs;
      });
    }
    return this.$q(resolve => resolve(this._attrs));
  }
}
